<template>
    <div class="ed-fileview team-detail" @click="clear" @contextmenu.stop>
        <div class="fileview-title">
            <div class="curteam-name text-ellipsis" :title="curTeam.name">{{ curTeam.name }}</div>
            <div class="btns">
                <div class="create-btn" v-if="curTeam.role >= 2" @click="openCreateModal()">
                    <span>+</span>
                    {{ $t("create") }}
                </div>
                <div class="import-btn btn" v-if="curTeam.role >= 2 && vipState" @click="openFileSelectedModal()">
                    <img :src="require('@/home/assets/img/team/import.svg')" alt="" />
                    <span>{{ $t("importFile") }}</span>
                </div>
                <div class="line" v-if="curTeam.role >= 2"></div>
                <div class="member-btn btn icon-btn" v-tippy="{ placement: 'bottom' }" :content="$t('memberManage')" @click="openShareLinkModal">
                    <img :src="require('@/home/assets/img/team/member.svg')" alt="" />
                </div>
                <div
                    class="setting-btn btn icon-btn"
                    v-tippy="{ placement: 'bottom' }"
                    :content="$t('setting')"
                    v-if="curTeam.role > 3"
                    @click="showSettingModal"
                >
                    <img :src="require('@/home/assets/img/team/setting.svg')" alt="" />
                </div>
                <div class="tool-btn btn icon-btn" @click="setLayout">
                    <img class="tool-icon" :src="require(`@/home/assets/pcview/${layoutMode}-mode.svg`)" />
                </div>
            </div>
        </div>

        <div v-if="layoutMode == 'list'" class="fileview-list-header fileview-list-header-team">
            <div class="file-name">
                <span>{{ $t("name") }}</span>
            </div>
            <div class="file-time">
                <span>{{ $t("time") }}</span>
            </div>
            <div class="file-creator">
                <span>{{ $t("creator") }}</span>
            </div>
            <div class="file-size">
                <span>{{ $t("size") }}</span>
            </div>
            <div class="file-select"></div>
        </div>

        <div class="fileview-scroll" @scroll="clear" ref="filesScroll">
            <div class="emptyCloud" v-cloak v-if="!$store.state.showLoading && userInfo && curTeamFiles && curTeamFiles.length == 0">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>

            <template v-if="layoutMode == 'grid'">
                <div class="files-box" ref="filesBoxList">
                    <gridFile
                        v-for="(item, index) in curTeamFiles"
                        :key="index"
                        :type="'team'"
                        :mode="''"
                        :index="index"
                        :file="item"
                        @closeContextmenu="contextmenuBoxShow = false"
                    />
                </div>
            </template>

            <template v-if="layoutMode == 'list'">
                <div class="files-box-list files-box-list-recent" ref="filesBoxList">
                    <listFile
                        v-for="(item, index) in curTeamFiles"
                        :key="index"
                        :type="'team'"
                        :mode="''"
                        :index="index"
                        :file="item"
                        @closeContextmenu="contextmenuBoxShow = false"
                    />
                </div>
            </template>
        </div>

        <fileSelector :title="$t('importFile')" @on-ok="importFile" />

        <Modal :title="$t('createFile')" class-name="vertical-center-modal" v-model="createModal" @on-ok="newFile()" width="360px">
            <div>
                <Input ref="newFileInput" v-model="newFileName"></Input>
            </div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn" @click="newFile()">{{ $t("okText") }}</div>
                <div class="cancel-btn btn" @click="createModal = false">{{ $t("cancelText") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>
        <Modal :title="$t('setting')" class-name="vertical-center-modal setting-modal" v-model="settingModal" width="520px" :footer-hide="true">
            <div class="title">{{ $t("spaceName") }}</div>
            <div class="content">
                <div class="content-name">{{ curTeam.name }}</div>
                <div class="change-btn btn" @click="changeTeamName">{{ $t("changeName") }}</div>
            </div>
            <template v-if="curTeam.role > 3">
                <div class="title">{{ $t("deleteSpace") }}</div>
                <div class="content">
                    <div style="max-width: 380px">{{ $t("deleteSpaceTip") }}</div>
                    <div class="delete-btn btn" @click="deleteTeam">{{ $t("delete") }}</div>
                </div>
            </template>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>
        <Modal class-name="vertical-center-modal go-teams-modal" v-model="goTeamsModal" width="520px" :footer-hide="true">
            <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
            <div class="tip">{{ goTeamsTip }}</div>
            <div class="go-teams-btn" @click="goTeams">{{ $t("ok") }}</div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>
        <Modal v-model="reFileNameModal" :mask-closable="false" :title="$t('rename')" class-name="modal-reTaamName" width="360px">
            <div>
                <Input ref="reFileInput" v-model="newReFileName"></Input>
            </div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn" @click="reFileName()">{{ $t("okText") }}</div>
                <div class="cancel-btn btn" @click="reFileNameModal = false">{{ $t("cancelText") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>

        <Modal v-model="delFileConfirmModal" :mask-closable="false" :title="$t('tip')" width="360px">
            <div>{{ $t("deleteFileTip") }}</div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn red-btn" @click="deleteFile()">{{ $t("delete") }}</div>
                <div class="cancel-btn btn" @click="delFileConfirmModal = false">{{ $t("cancelText") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>

        <Modal
            v-model="memberModal"
            width="540px"
            :footer-hide="true"
            class-name="member-modal modal-shareLink"
            @on-visible-change="changeMemberModal"
        >
            <div slot="header" class="header">
                <template v-if="curTeam.role > 2">
                    <div class="menber-modal-title">
                        <span>{{ $t("memberManage") }}</span>
                        <img
                            :src="require('@/home/assets/img/user/topbar/help.svg')"
                            alt=""
                            v-tippy="{ placement: 'top' }"
                            :content="$t('permissionExplanation')"
                            @click="permmissionTipModal = true"
                        />
                    </div>
                </template>
                <template v-else>
                    <span>{{ $t("teamMembers") }}</span>
                </template>
            </div>
            <div class v-if="curTeam.role >= 3">
                <div class="body">
                    <p class="text-1">
                        {{ $t("urlHint") }}
                        <a href="javascript:void(0)" @click="createTeamShareLink(shareRole)">{{ $t("refresh") }}</a>
                    </p>
                    <div class="share-box">
                        <div class="text-link">{{ curTeamShareLink }}</div>
                        <div class="team-share-dropdown">
                            <dropDown :roleList="roleList" @changeRoleList="changeRoleList" />
                        </div>
                        <div class="clipaction" @click="copyClip()">
                            {{ $t("copyUrl") }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- <Divider v-if="curTeam.role >= 3"></Divider> -->
            <div class="member-list">
                <div class="member-item" v-for="item in curTeamMembers" :key="item.user_id">
                    <span class="member-info">
                        <div class="member-avatar">
                            <img :src="item.avatar_url" class="avatar-img" v-if="item.avatar_url" />
                            <div class="no-icon" v-else-if="item">{{ getFirstName(item) }}</div>
                            <iconSymbol class="noavatar" name="default-avatar" v-else></iconSymbol>
                        </div>
                        <span class="member-name text-ellipsis" :title="item.nick_name">{{ item.nick_name }}</span>
                    </span>
                    <template v-if="curTeam.role >= 3">
                        <span v-if="item.role < curTeam.role">
                            <Dropdown trigger="click" placement="bottom-end" @on-click="updateMemberRole">
                                <div style="cursor: pointer; color: #222">
                                    {{ $t("memberRole[" + item.role + "]") }}
                                    <Icon class="ios-arrow" type="ios-arrow-down" />
                                </div>
                                <Dropdown-menu slot="list">
                                    <Dropdown-item :name="item.user_id + ',3'" v-if="curTeam.role === 4">
                                        <div class="choosed-img">
                                            <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="item.role === 3" />
                                        </div>
                                        <div>
                                            {{ $t("memberRole.3") }}
                                            <div class="tip">{{ $t("dropTip.manager") }}</div>
                                        </div>
                                    </Dropdown-item>
                                    <Dropdown-item :name="item.user_id + ',2'">
                                        <div class="choosed-img">
                                            <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="item.role === 2" />
                                        </div>
                                        <div>
                                            {{ $t("memberRole.2") }}
                                            <div class="tip">{{ $t("dropTip.editor") }}</div>
                                        </div>
                                    </Dropdown-item>
                                    <Dropdown-item :name="item.user_id + ',1'">
                                        <div class="choosed-img">
                                            <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="item.role === 1" />
                                        </div>
                                        <div>
                                            {{ $t("memberRole.1") }}
                                            <div class="tip">{{ $t("dropTip.reader") }}</div>
                                        </div>
                                    </Dropdown-item>
                                    <Dropdown-item :name="item.user_id + ',5'" divided class="remove">
                                        <div style="display: flex">
                                            <div class="choosed-img"></div>
                                            {{ $t("removeMember") }}
                                        </div>
                                    </Dropdown-item>
                                </Dropdown-menu>
                            </Dropdown>
                        </span>
                        <span v-else>
                            <span v-if="item.role !== 3 || (item.role === 3 && !item.isCurrentUser)">{{ $t("memberRole[" + item.role + "]") }}</span>
                            <Dropdown trigger="click" placement="bottom-end" @on-click="updateMemberRole" v-else>
                                <div style="cursor: pointer;color #222">
                                    {{ $t("memberRole[" + item.role + "]") }}
                                    <Icon class="ios-arrow" type="ios-arrow-down" />
                                </div>
                                <Dropdown-menu slot="list">
                                    <Dropdown-item :name="item.user_id + ',3'">
                                        <div class="choosed-img">
                                            <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="item.role === 3" />
                                        </div>
                                        <div>
                                            {{ $t("memberRole.3") }}
                                            <div class="tip">{{ $t("dropTip.manager") }}</div>
                                        </div>
                                    </Dropdown-item>
                                    <Dropdown-item :name="item.user_id + ',6'" divided class="remove">
                                        <div style="display: flex">
                                            <div class="choosed-img"></div>
                                            {{ $t("leaveTeam") }}
                                        </div>
                                    </Dropdown-item>
                                </Dropdown-menu>
                            </Dropdown>
                        </span>
                    </template>
                    <template v-else>
                        <span v-if="item.role !== curTeam.role || (item.role < 3 && !item.isCurrentUser)">
                            {{ $t("memberRole[" + item.role + "]") }}
                        </span>
                        <div v-else>
                            <Dropdown trigger="click" placement="bottom-end" @on-click="updateMemberRole">
                                <div style="cursor: pointer;color #222">
                                    {{ $t("memberRole[" + item.role + "]") }}
                                    <Icon class="ios-arrow" type="ios-arrow-down" />
                                </div>
                                <Dropdown-menu slot="list">
                                    <Dropdown-item :name="item.user_id + ',3'" v-if="curTeam.role === 4 && item.role === 3">
                                        <div class="choosed-img">
                                            <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="item.role === 3" />
                                        </div>
                                        <div>
                                            {{ $t("memberRole.3") }}
                                            <div class="tip">{{ $t("dropTip.manager") }}</div>
                                        </div>
                                    </Dropdown-item>
                                    <Dropdown-item :name="item.user_id + ',2'" v-if="item.role === 2">
                                        <div class="choosed-img">
                                            <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="item.role === 2" />
                                        </div>
                                        <div>
                                            {{ $t("memberRole.2") }}
                                            <div class="tip">{{ $t("dropTip.editor") }}</div>
                                        </div>
                                    </Dropdown-item>
                                    <Dropdown-item :name="item.user_id + ',1'" v-if="item.role === 1">
                                        <div class="choosed-img">
                                            <img :src="require('@/home/assets/img/team/chosed.svg')" alt="" v-if="item.role === 1" />
                                        </div>
                                        <div>
                                            {{ $t("memberRole.1") }}
                                            <div class="tip">{{ $t("dropTip.reader") }}</div>
                                        </div>
                                    </Dropdown-item>
                                    <Dropdown-item :name="item.user_id + ',6'" divided class="remove" v-if="item.isCurrentUser">
                                        <div style="display: flex">
                                            <div class="choosed-img"></div>
                                            {{ $t("leaveTeam") }}
                                        </div>
                                    </Dropdown-item>
                                </Dropdown-menu>
                            </Dropdown>
                        </div>
                    </template>
                </div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>

        <Modal v-model="permmissionTipModal" :mask-closable="false" :title="$t('permissionExplanation')" width="420px" class-name="member-tip">
            <div class="title">{{ $t("explanations.noVip") }}</div>
            <div class="no-vip-content">{{ $t("explanations.noVipTip") }}</div>
            <div class="title">{{ $t("explanations.vip") }}</div>
            <div>{{ $t("explanations.owner") }}</div>
            <div>{{ $t("explanations.manager") }}</div>
            <div>{{ $t("explanations.editor") }}</div>
            <div>{{ $t("explanations.reader") }}</div>
            <div slot="footer" class="footer-btns">
                <div class="ok-btn btn" @click="permmissionTipModal = false">{{ $t("ok") }}</div>
            </div>
            <div slot="close" class="close-icon" style="margin-right: 12px; margin-top: 12px; cursor: pointer">
                <img :src="require('@/home/assets/img/team/close.svg')" alt="" />
            </div>
        </Modal>

        <RightMenu
            v-if="contextmenuBoxShow && curTeam.role !== 1 && vip"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="rightmenuList"
            @handleClicks="handleClick($event)"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    import listFile from "../onlineView/listFile.vue";
    import gridFile from "../onlineView/gridFile.vue";
    import dropDown from "../dropDown.vue";
    import fileSelector from "./fileSelector.vue";
    import RightMenu from "../RightMenu.vue";
    import appConfig from "@/public/globalConfig";

    declare var CreateNewFile: any;

    @Component({
        components: {
            listFile,
            gridFile,
            fileSelector,
            RightMenu,
            dropDown,
        },
    })
    export default class list extends Vue {
        @Prop() team: object;

        createModal = false;
        newFileName = "";
        createFileBlock = false;
        settingModal = false;
        memberModal = false;
        permmissionTipModal = false;
        shareRole = 1;
        roleList = [
            {
                id: 0,
                role: 1,
                label: "reader",
            },
            {
                id: 1,
                role: 2,
                label: "editor",
            },
            {
                id: 2,
                role: 3,
                label: "manager",
            },
        ];

        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }

        get rightmenuList() {
            let list = [
                {
                    key: 0,
                    label: this.$t("rename"),
                },
                { key: 1, label: this.$t("deleteFile") },
            ];
            console.log("this.vip", this.vip);
            if ((this.$store.getters.curTeam && this.$store.getters.curTeam.role === 1) || !this.vip) {
                return [];
            }
            return list;
        }

        get curTeam() {
            let team = this.$store.getters.curTeam;
            if (team) {
                return team;
            } else {
                return { id: "", name: "" };
            }
        }

        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }

        get userInfo() {
            return this.$store.state.userInfo;
        }

        get curTeamFiles() {
            let team = this.$store.getters.curTeam;
            if (team && team.files) {
                return team.files;
            } else {
                return [];
            }
        }

        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }

        get fileSelected() {
            if (this.$store.state.selectFilesIndex.length > 0 && this.curTeamFiles.length > 0) {
                return this.curTeamFiles[this.$store.state.selectFilesIndex[0]];
            } else {
                return null;
            }
        }

        selectedFile = {
            key: "",
            info: { id: "" },
            name: "",
        };
        newReFileName = "";

        reFileNameModal = false;
        showRenameModal() {
            this.reFileNameModal = true;
            this.newReFileName = this.fileSelected.name;
            this.$nextTick(() => {
                (this.$refs["reFileInput"] as any).focus();
            });
            this.clear();
        }

        delFileConfirmModal = false;
        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.showRenameModal();
                    },
                ],
                [
                    1,
                    () => {
                        this.delFileConfirmModal = true;
                    },
                ],
            ]);
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
            this.clear();
        }
        // showMenu({ e, file }) {
        //     console.log("store",this.$store);
        //     e.preventDefault();
        //     e.stopPropagation();

        //     this.selectedFile = file;
        //     this.newReFileName = file.name;
        // }
        setLayout() {
            this.$store.commit("changeLayout");
            this.clear();
        }

        openCreateModal() {
            this.sensors.track("newFileSpace", {
                Catalogues: "Team",
            });
            let owner = this.curTeam.role == 3,
                valid = this.curTeam.valid;
            if (owner && !valid) {
                if (!this.$checkAuth({ type: "team" })) return;
            }

            this.createModal = true;
            this.$nextTick(() => {
                (this.$refs["newFileInput"] as any).focus();
            });
        }
        clear() {
            this.contextmenuBoxShow = false;
        }

        newFile() {
            if (this.newFileName == "") {
                this.$edMessage.warning(this.$t("noFileNameTip"));
                return;
            }
            if (this.newFileName.length > 100) {
                this.$edMessage.warning(this.$t("fileNameLimit"));
                return;
            }

            let p = new RegExp("(?=[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%])", "g");
            if (p.test(this.newFileName)) {
                this.$edMessage.warning(this.$t("invalidName"));
                return;
            }
            if (this.createFileBlock) return;
            this.createFileBlock = true;
            let teamId = this.curTeam.id;
            let path = this.getPublicPath();
            const curTeamFiles = this.curTeamFiles;
            if (curTeamFiles.length > 0) {
                // 原来存在文件则过滤一遍文件名
                let arr = curTeamFiles.map((v) => v.name);
                this.newFileName = this.checkName(this.newFileName, arr);
            }
            let index = this.internal ? 0 : 1,
                docName = `${this.newFileName}.eddx`,
                screenW = window.screen.width * window.devicePixelRatio,
                screenH = window.screen.height * window.devicePixelRatio,
                createTime = this.getCreateTime(),
                creater = this.$store.state.userInfo.nick_name,
                maxVersion = this.appVersion;
            let createTool = new CreateNewFile(index, docName, screenW, screenH, createTime, creater, maxVersion);
            const uploadPreview = (res: any) => {
                // 上传空白预览图
                let dataURLtoBlob = () => {
                    let dataurl =
                        "data:image/png;base64,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";
                    var arr = dataurl.split(","),
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]),
                        n = bstr.length,
                        u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new Blob([u8arr], { type: mime });
                };
                let img_sign = res.img_up_sign;
                let imageOssParams = {
                    url: res.img,
                    exp: res.up_exp,
                    sign: img_sign,
                    file: dataURLtoBlob(),
                    contentType: "image/png",
                };
                return this.$edApi.uploadOSSFile(imageOssParams);
            };
            createTool.createFile().then((e) => {
                // saveAs(e[0], e[1])
                let fileInfo = {
                    fileName: `${path}${this.newFileName}.eddx`,
                    name: this.newFileName,
                    size: e[0].size,
                };
                let params = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    teamId,
                };
                const uploadList = [];
                this.$edApi
                    .getTeamUploadSignature(params, fileInfo)
                    .then((res) => {
                        // 上传文件
                        let url = res.obj;
                        let sign = res.obj_up_sign;
                        let exp = res.up_exp;
                        let ossParams = {
                            url,
                            exp,
                            sign,
                            file: e[0],
                            contentType: "application/octet-stream",
                        };
                        uploadList.push(uploadPreview(res));
                        uploadList.push(this.$edApi.uploadOSSFile(ossParams));
                        Promise.all(uploadList)
                            .then(() => {
                                this.createFileBlock = false;
                                this.newFileName = "";
                                this.getTeamFiles();
                                this.createModal = false;
                                this.sensors.track("newFile", {
                                    Catalogues: "openFileProcess",
                                    new_file_way: "teamspace",
                                });
                            })
                            .catch((e) => {
                                this.createFileBlock = false;
                                this.createModal = false;
                                this.$edMessage.warning(this.$t("createFail"));
                            });
                    })
                    .catch((e) => {
                        console.log(e);
                        if (e == "Not locked or locked by others") {
                            console.log("create fail");
                        }
                        if (e === "not found") {
                            (<any>this).goTeamsTip = this.$t("spaceDeleted");
                            this.goTeamsModal = true;
                        }
                        this.createFileBlock = false;
                        this.createModal = false;
                    });
            });
        }
        getPublicPath() {
            let path = "";
            let currentID = this.$store.state.team.curTeamId;
            let teams = this.$store.state.team.teams;
            for (let i = 0; i < teams.length; i++) {
                if (teams[i].id == currentID) {
                    return teams[i].path;
                }
            }
        }
        checkName(name, list) {
            let exit = 0,
                exitExpand = 0,
                exitFlag = true,
                numList = [];
            let p = new RegExp("(?=[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%])", "g"),
                ruleone = new RegExp("^" + name.replace(p, "\\") + "\\(\\d+\\)$"),
                ruletwo = new RegExp("^" + name.replace(p, "\\") + "\\((\\d*)");

            for (let v of list) {
                if (exitFlag && v == name) {
                    exit = 1;
                    exitFlag = false;
                }
                if (ruleone.test(v)) {
                    let tempNum = ~~v.match(ruletwo)[1];
                    if (tempNum > 0) {
                        numList.push(tempNum);
                        exitExpand = 1;
                    }
                }
            }

            if (exit == 0) {
                return name;
            } else {
                if (exitExpand != 1) {
                    return `${name}(1)`;
                } else {
                    numList = numList.sort((a, b) => {
                        return a - b;
                    });
                    var k;
                    for (var i = 0, len = numList.length; i < len; i++) {
                        if (i + 1 != numList[i]) {
                            k = i + 1;
                            break;
                        } else {
                            k = numList[len - 1] + 1;
                        }
                    }
                    return `${name}(${k})`;
                }
            }
        }
        getCreateTime() {
            let datetime = new Date();
            let year = datetime.getFullYear();
            let month: any = datetime.getMonth() + 1; //js从0开始取
            let date: any = datetime.getDate();
            let hour: any = datetime.getHours();
            let minutes: any = datetime.getMinutes();
            let second: any = datetime.getSeconds();

            if (month < 10) {
                month = "0" + month;
            }
            if (date < 10) {
                date = "0" + date;
            }
            if (hour < 10) {
                hour = "0" + hour;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (second < 10) {
                second = "0" + second;
            }

            let time = year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + second;
            return time;
        }
        getTeamFiles() {
            this.$store.commit("setState", { data: true, type: "showLoading" });
            if (!this.curTeam || !this.curTeam.id) return;
            let teamId = this.curTeam.id;
            this.$store
                .dispatch("getTeamFiles", teamId)
                .then((res) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        receiveMessage(event) {
            // 我们能信任信息来源吗？
            if (event.origin !== location.origin) return;
            if (event.data == "updateTeamFile") {
                this.getTeamFiles();
            }
        }
        getTeamMembers() {
            if (!this.curTeam || !this.curTeam.id) return;
            let teamId = this.curTeam.id;
            this.$store.dispatch("getTeamMembers", teamId).then((res) => {});
        }

        goTeamsModal = false;
        goTeamsTip = "";
        showSettingModal() {
            if (!this.curTeam || !this.curTeam.id) return;
            this.settingModal = true;
            this.sensors.track("spaceSettings", {
                Catalogues: "Team",
            });
        }

        changeTeamName() {
            this.$bus.$emit("changeTeamName", this.curTeam);
            // this.settingModal = false;
        }

        deleteTeamInfo = {
            deleted: false,
            id: 0,
        };
        deleteTeam() {
            this.$bus.$emit("deleteTeam", this.curTeam);
            // this.settingModal = false;
            this.deleteTeamInfo = {
                deleted: true,
                id: this.curTeam.id,
            };
        }

        goTeams() {
            this.goTeamsModal = false;
            this.$router.push("teams");
        }

        openFileSelectedModal() {
            this.sensors.track("importToSpace", {
                Catalogues: "Team",
            });
            if (!this.curTeam || !this.curTeam.id) return;

            let owner = this.curTeam.role == 3,
                valid = this.curTeam.valid;
            if (owner && !valid) {
                if (!this.$checkAuth({ type: "team" })) return;
            } else if (!valid) {
                this.$edMessage.warning(this.$t("createFail"));
                return;
            }

            this.$store.commit("setState", {
                type: "showGroupFileSelector",
                data: true,
            });
        }

        importFile(fileInfo) {
            this.sensors.track("confirmImportToSpace", {
                Catalogues: "Team",
            });
            this.importTeamFileFromCloud(fileInfo);
        }
        importTeamFileFromCloud(fileInfo) {
            let id = fileInfo.id;
            if (!this.curTeam || !this.curTeam.id) return;
            let teamId = this.curTeam.id;
            let file_key = fileInfo.file_key;
            this.$store
                .dispatch("importTeamFilesFromCloud", {
                    teamId,
                    id,
                    file_key,
                })
                .then((res) => {
                    this.getTeamFiles();
                })
                .catch((err) => {
                    if (err == "noTeamSpace") {
                        (<any>this.$Modal).warning({
                            title: this.$t("noSpace"),
                            content: this.$t("noSpaceHint"),
                            cancelText: "",
                        });
                    }
                });
        }

        reFileName() {
            if (!this.curTeam || !this.fileSelected) return;
            if (!this.newReFileName) {
                this.$edMessage.warning(this.$t("noFileNameTip"));
                return;
            }
            if (this.fileSelected.name == this.newReFileName) return;

            let files = this.curTeamFiles;
            let index = 1;
            let temp = this.newReFileName;
            while (
                files.find((file) => {
                    return file.name == temp;
                })
            ) {
                temp = `${this.newReFileName}(${index})`;
                index++;
            }
            this.newReFileName = temp;

            let teamId = this.curTeam.id,
                fileId = this.fileSelected.info.id;
            this.$store
                .dispatch("renameTeamFile", {
                    teamId,
                    obj_id: fileId,
                    to: this.newReFileName,
                    name: this.newReFileName,
                    file_key: this.fileSelected.info.file_key,
                })
                .then((res) => {
                    this.$emit("get-files");
                    this.reFileNameModal = false;
                    this.getTeamFiles();
                });
            this.clear();
        }

        deleteFile() {
            if (!this.curTeam || !this.fileSelected) return;
            let teamId = this.curTeam.id,
                fileId = this.fileSelected.info.id,
                file_key = this.fileSelected.info.file_key;
            this.$store.dispatch("deleteTeamFile", { teamId, fileId, file_key }).then((res) => {
                this.delFileConfirmModal = false;
                this.getTeamFiles();

                this.$emit("get-files");
            });
            this.clear();
        }

        createTeamShareLink(role) {
            if (!this.curTeam || !this.curTeam.id) return;
            let teamId = this.curTeam.id;
            this.$store.dispatch("createTeamShareLink", { teamId, role }).then((res) => {});
        }

        get curTeamShareLink() {
            if (this.$store.getters.curTeam && this.$store.getters.curTeam.shareLink) {
                return location.origin + appConfig.sourcePath + this.lang + "/teams?inviteCode=" + this.$store.getters.curTeam.shareLink;
            } else {
                if (!this.$store.getters.curTeam.shareLink) {
                    this.createTeamShareLink(this.shareRole);
                }
                return "";
            }
        }
        get curTeamMembers() {
            if (this.$store.getters.curTeam) {
                const list = this.$store.getters.curTeam.members || [];
                list.map((item) => {
                    if (item.user_id === this.userInfo.user_id) {
                        item.isCurrentUser = true;
                    }
                });
                return list;
            } else {
                return [];
            }
        }

        changeRoleList(data) {
            this.shareRole = data.role;
            this.createTeamShareLink(this.shareRole);
        }
        copyClip() {
            let shareLink = this.curTeamShareLink;
            if (!shareLink) {
                return;
            }
            this.sensors.track("copySpacelink", {
                Catalogues: "Team",
            });
            let oInput = document.createElement("input");
            oInput.value = shareLink;
            document.body.appendChild(oInput);
            oInput.select();
            document.execCommand("Copy");
            oInput.style.display = "none";
            document.body.removeChild(oInput);
            this.$edMessage.success(this.$t("urlCopied"));
        }
        updateMemberRole(value) {
            if (!this.curTeam || !this.curTeam.id) return;
            let arr = value.split(","),
                userId = arr[0],
                role = arr[1],
                isDelete = 0;

            let teamId = this.curTeam.id;

            if (role == 5) {
                this.$store
                    .dispatch("removeTeamMember", {
                        teamId,
                        userId,
                    })
                    .then((res) => {
                        this.getTeamMembers();
                    });
            } else if (role == 6) {
                this.exitTeam();
                return;
            } else {
                this.$store
                    .dispatch("updateTeamMember", {
                        teamId,
                        userId,
                        role,
                        isDelete,
                    })
                    .then((res) => {
                        this.getTeamMembers();
                    });
            }
        }

        openShareLinkModal() {
            // if(this.isDelete){
            //     this.goTeamsTip = "该空间已解散，信息已无法查看";
            //     this.goTeamsModal = true;
            //     return
            // }

            let owner = this.curTeam.role == 3,
                valid = this.curTeam.valid;
            if (owner && !valid) {
                // 管理员可添加群成员
                // if (!this.$checkAuth({ type: "team" })) return;
            } else if (!valid) {
                // this.$edMessage.warning(this.$t("createFail"));
                this.memberModal = true;
                this.sensors.track("memberManagement", {
                    Catalogues: "Team",
                });
                return;
            }
            if (this.isPrivate) {
                this.$store.commit("setTeamState", {
                    type: "showTeamInviteModal",
                    data: true,
                });
                return;
            }
            if (!this.$store.getters.curTeam.shareLink) {
                this.createTeamShareLink(this.shareRole);
            }
            this.memberModal = true;
            this.sensors.track("memberManagement", {
                Catalogues: "Team",
            });
        }

        exitTeam() {
            if (!this.curTeam || !this.curTeam.id) return;
            (<any>this.$Modal).confirm({
                title: this.$t("tip"),
                content: this.$t("confirmLeave"),
                okText: this.$t("exit"),
                cancelText: this.$t("cancelText"),
                onOk: () => {
                    this.sensors.track("exitTeam", {
                        Catalogues: "Team",
                    });
                    let teamId = this.curTeam.id;
                    this.$store.dispatch("exitTheTeam", teamId).then((res) => {
                        this.$router.replace(`/${this.lang}/teams`);
                        this.$store.dispatch("getTeamList").then((res) => {
                            this.$store.commit("setState", { data: false, type: "showLoading" });
                        });
                        this.memberModal = false;
                    });
                },
            });
        }

        getFirstName(item) {
            return item.nick_name.trim().split("")[0];
        }

        changeMemberModal(val) {
            if (!val) {
                this.sensors.track("memberManagementPopupCloseButton", {
                    Catalogues: "Team",
                });
            }
        }

        @Watch("curTeam", { immediate: true, deep: true })
        onCurTeamChanged(team: any, oldTeam: any) {
            if (team) {
                if (!team.files) {
                    this.getTeamFiles();
                }
                if (!team.members) {
                    this.getTeamMembers();
                }
            }
        }

        mounted() {
            this.$bus.$on("joinTeamFailed", (res) => {
                this.goTeamsTip = res;
                this.goTeamsModal = true;
            });
            this.$bus.$on("showMember", (res) => {
                this.openShareLinkModal();
            });
            this.$bus.$on("clear", (res) => {
                this.clear();
            });
            this.$bus.$on("confirmDeleteTeam", () => {
                this.$router.push("teams");
                this.$store.commit("setState", { data: false, type: "showLoading" });
            });
            this.$bus.$on("closeSetting", () => {
                this.settingModal = false;
            });
            // this.$nextTick(()=>{
            //     console.log("curTeamShareLink",(<any>this).curTeamShareLink)
            //     console.log("shareRole",this.shareRole)
            //     if(!this.curTeamShareLink){
            //         this.createTeamShareLink(this.shareRole)
            //     }
            // })
        }

        created() {
            // console.log(12312312312)
            window.addEventListener("message", this.receiveMessage, false);
        }
        beforeDestroy() {
            window.removeEventListener("message", this.receiveMessage);
        }
    }
</script>

<style lang="stylus" scoped>
          /deep/ .ivu-modal-body
                padding 8px 24px
          .team-detail
                .fileview-title
                      display flex
                      justify-content space-between
                      align-items center
                      padding-right 32px
                      .curteam-name
                        max-width 400px
                      .btns
                            display flex
                            align-items center
                            .line
                                  width 1px
                                  height 28px
                                  background rgba(0, 0, 0, 0.08)
                                  margin 0 12px
                            .btn
                                  border 1px solid rgba(0,0,0,0.08)
                                  border-radius 4px
                                  cursor pointer
                                  &:hover
                                        background rgba(242,244,249,0.6)
                            .icon-btn
                                  display flex
                                  width 28px
                                  height 28px
                                  padding 6px
                                  justify-content center
                                  align-items center
                                  margin-right 12px
                                  &:last-child
                                        margin-right 0

                            .create-btn
                                  display inline-flex
                                  height 28px
                                  padding 6px 16px 6px 12px
                                  justify-content center
                                  align-items center
                                  border-radius 4px
                                  background #017FFF
                                  color #fff
                                  font-size 14px
                                  font-weight 400

                                  cursor pointer
                                  &:hover
                                        opacity 0.8
                                  span
                                        margin-right 2px

                            .import-btn
                                  display inline-flex
                                  align-items center
                                  height 28px
                                  font-size 14px
                                  font-weight 400
                                  padding 6px 16px 6px 12px
                                  margin-left 12px

    .footer-btns
        display flex
        justify-content flex-end
        bottom 24px
        right 24px
        padding-top 8px
        .btn
            width 72px
            height 28px
            text-align center
            line-height 28px
            border-radius 6px
            font-size 12px
            cursor pointer
            &:hover
                opacity 0.8
        .ok-btn
            margin-right 16px
            background #017FFF
            color #fff
        .cancel-btn
            background #EBEDF1
            color #000
        .red-btn
            background #FF4040

    .setting-modal
          .title
                margin 8px 0 16px
                font-weight 700
                color #222
          .btn
                border 1px solid rgba(0,0,0,0.08)
                border-radius  6px
                height 32px
                line-height 32px
                padding 0 20px
                cursor pointer
                color #222
                &:hover
                      border-color #017FFF
                      color #017FFF
          .content
                display flex
                justify-content space-between
                align-items center
                margin-bottom 32px
                color #222
            .content-name
                max-width 350px
                word-wrap break-word
                color #222
          .delete-btn
                color #FF4040
                &:hover
                    opacity 0.8
            .ok-btn
                margin-right 16px
                background #017FFF
                color #fff
            .cancel-btn
                background #EBEDF1
                color #000
            .red-btn
                background #FF4040

        .setting-modal
              .delete-btn
                    color #FF4040
                    &:hover
                          border-color #FF4040
                          color #FF4040


    .member-modal
        .header
            display flex
            align-items center
            font-size 14px
            font-weight 700
            span
                margin-right 8px
                color #222
            .menber-modal-title
                display flex
                align-items center
        .body
            .text-1
                color #222
                margin-bottom 16px
            .text-link
                color #222
            .team-share-dropdown
                color #222
                /deep/.ed-dropdown
                    width 65px
                    .ed-dropdown-list
                        width 100px
                        position relative
                        left -30px
                        li
                            display flex
                    .choosed-img
                        vertical-align middle


        .member-name
            max-width 350px
            color #222

        .exit-team
            width 60px

    .member-list
        .member-item
            font-size 14px
            color #222
            .member-name
                color #222
            .choosed-img
                margin-right 8px
                display block
                width 16px
                height 16px
                margin-right 8px
            .tip
                font-size 12px
                color rgba(0,0,0,0.5)
    .member-tip
        .title
            font-weight 700
            margin-bottom 8px
        .no-vip-content
            margin-bottom 24px


    /deep/.fileview-files-item-list
        .file-name
            padding-right 20px
        .file-creator
            padding-right 20px

    /deep/.ivu-modal-header
      height 40px

        /deep/.ivu-modal-header
          height 40px

    .ivu-dropdown-item
        display flex
        align-items flex-start
        color #222
        font-size 14px
    .ivu-dropdown-item.remove
            display block
    /deep/.ivu-modal-wrap
        .ivu-modal-footer
            padding 8px 24px 24px
        .ivu-modal-header
            padding 12px 24px
        .ivu-modal-body
            padding 16px 24px
    /deep/.ivu-input:focus
        box-shadow unset

    .close-icon
        margin-right 12px
        margin-top 12px
        cursor pointer
        &:hover
            opacity 0.6
</style>

<i18n>
    {
      "zh": {
        "name": "文件名",
        "size": "文件大小",
        "notTem": "该团队还未创建文件",
        "time": "创建时间",
        "creator": "创建者",
        "importFile": "导入到空间",
        "noSpace": "云空间已满",
        "noSpaceHint": "此群的云空间已满，无法增加更多文件。",
        "createFail": "创建失败，请重试",
        "rename": "重命名",
        "confirmLeave": "退出团队后将无法再看团队空间入口及共享文件，确认要退出吗",
        "okText": "确定",
        "cancelText": "取消",
        "exit": "退出",
        "fileNameLimit": "文件名称最长为100",
        "urlHint": "分享如下链接即可邀请成员加入空间，链接60分钟内有效。",
        "refresh": "刷新",
        "copyUrl": "复制链接",
        "removeMember": "删除权限",
        "memberRole": {
            "1": "可查看",
            "2": "可编辑",
            "3": "可管理",
            "4": "所有者"
        },
        "readerHint": "阅读者：只能查看群文件",
        "editorHint": "编辑者：能够编辑查看群文件",
        "adminHint": "管理者：以上所有权限及删除群文件、邀请新用户和删除以上两种用户",
        "ownerHint": "所有者：以上所有权限及删除管理员",
        "urlCopied": "邀请链接已复制到剪切板",
        "invalidName": "名字不能包含特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
        "setting": "空间设置",
        "spaceName": "空间名称",
        "changeName": "修改名称",
        "deleteSpaceTip": "删除后空间将被解散，空间内所有文件将被删除且无法恢复",
        "deleteSpace": "删除空间",
        "deleteFile": "删除文件",
        "delete": "删除",
        "create": "新建",
        "createFile": "创建文件",
        "ok": "好的",
        "noFileNameTip": "请输入文件名",
        "tip": "提示",
        "deleteFileTip": "删除项目文件后将无法恢复，确认是否删除?",
        "memberManage": "成员管理",
        "permissionExplanation": "权限说明",
        "explanations": {
            "vip": "会员用户",
            "noVip": "非会员用户",
            "noVipTip": "不能创建空间，不能新增空间文件，其他角色权限与会员用户一致",
            "owner": "所有者：空间创建人。管理成员，空间内所有文件权限",
            "manager": "可管理：修改成员；新增、编辑、删除空间文件",
            "editor": "可编辑：新增、编辑、删除空间文件",
            "reader": "可查看：仅能查看空间文件"
        },
        "dropTip": {
            "manager": "管理空间、成员",
            "editor": "创建、编辑文件",
            "reader": "仅支持浏览"
        },
        "leaveTeam": "退出团队",
        "createFail": "创建失败",
        "teamMembers": "团队成员",
        "spaceDeleted": "该空间已解散 或 您还没有该空间的权限，请联系空间管理员确认"
      },
      "en": {
        "size": "Size",
        "creator": "Creator",
        "createFile": "Create file",
        "importFile": "Import File",
        "leaveTeam": "Exit the group",
        "removeMember": "Remove permissions",
        "urlHint": "Share the following link to invite members to join the space. The link is valid for 60 minutes.",
        "refresh": "Refresh",
        "copyUrl": "Copy link",
        "memberRole": {
            "1": "Reader",
            "2": "Editor",
            "3": "Manager",
            "4": "Owner"
        },
        "readerHint": "Reader: can only view group files",
        "editorHint": "Editor: can view and edit group files",
        "adminHint": "Admin: can view, edit and delete group files; they can add, manage and remove group members",
        "ownerHint": "Owner: can view, edit and delete group files; they can add, manage and remove all three kinds of group members above",
        "noSpace": "The cloud storage is full.",
        "noSpaceHint": "The cloud storage of this group is full and no more files can be added.",
        "confirmDismiss": "Are you sure you want to delete this group?",
        "dismissHint": "You can no longer access and restore group files once the group is deleted.",
        "confirmLeave": "Are you sure you want to exit?",
        "okText": "OK",
        "cancelText": "Cancel",
        "createFail": "Creation failed, please try again",
        "urlCopied": "The invitation link has been copied to the clipboard.",
        "invalidName": "Invalid Name.check if the name contains special character, such as & % $ \\ \/ \" : * ? < > | . 😊, etc.",
        "setting": "Setting",
        "spaceName": "Space Name",
        "changeName": "Change",
        "deleteSpaceTip": "Upon deletion, the space will be disbanded. All files within the space will be deleted and cannot be recovered",
        "delete": "Delete",
        "deleteSpace": "Delete Space",
        "deleteFile": "Delete File",
        "create": "Create",
        "createFile": "Create File",
        "ok": "Ok",
        "exit": "Exit",
        "noFileNameTip": "Please enter the file name",
        "fileNameLimit": "The file name can be up to 100 characters long",
        "tip": "Message",
        "deleteFileTip": "Once the project files are deleted, they cannot be recovered. Are you sure you want to delete them?",
        "rename": "Rename",
        "memberManage": "Member Management",
        "permissionExplanation": "Permission Explanation",
        "explanations": {
            "vip": "VIP Users",
            "noVip": "Non-VIP Users",
            "noVipTip": "Cannot create spaces, cannot add new space files, other role permissions are consistent with VIP users.",
            "owner": "Owner: The creator of the space. Manages members, has all file permissions in the space.",
            "manager": "Manageable: Can modify members; add, edit, and delete space files.",
            "editor": "Editable: Can add, edit, and delete space files.",
            "reader": "Viewable: Can only view space files."
        },
        "dropTip": {
            "manager": "Manage space、members",
            "editor": "Create、edit files",
            "reader": "View only"
        },
        "notTem": "No files created in this team yet",
        "createFail": "Create Fail",
        "teamMembers": "Team Members",
        "spaceDeleted": "This space has been disbanded or you do not have the permissions for this space yet, please contact the space administrator to confirm.",
        "name": "File Name",
        "time": "Creation Time"
      },
      "fr": {
        "myTeam": "Équipes",
        "gridView": "Vue grille",
        "listView": "Vue liste",
        "fileName": "Nom du fichier",
        "creator": "Créateur",
        "size": "Taille",
        "modDate": "Date modifiée",
        "createFile": "Créer un fichier",
        "importFile": "Importer le fichier",
        "editTeamName": "Modifier le nom du groupe",
        "dismissTeam": "Dissoudre le groupe",
        "leaveTeam": "Quitter l'équipe",
        "help": "Aider",
        "teamMembers": "Membres du groupe",
        "add": "Ajouter",
        "more": "En savoir plus",
        "removeMember": "Supprimer les autorisations",
        "inviteUrl": "Lien d'invitation",
        "urlHint": "Partagez le lien suivant pour inviter des membres à rejoindre l'espace. Le lien est valide pendant 60 minutes.",
        "refresh": "Actualiser",
        "copyUrl": "Copier le lien",
        "memberRole": [
            null,
            "Lecteur",
            "Éditeur",
            "Manager",
            "Propriétaire"
        ],
        "readerHint": "Lecteur: ne peut afficher que les fichiers de groupe",
        "editorHint": "Éditeur: possibilité de modifier et d'afficher les fichiers de groupe",
        "adminHint": "Admin: peut afficher, modifier et supprimer des fichiers de groupe; ils peuvent ajouter, gérer et supprimer des membres du groupe",
        "ownerHint": "Propriétaire: peut afficher, modifier et supprimer des fichiers de groupe; ils peuvent ajouter, gérer et supprimer les trois types de membres du groupe ci-dessus",
        "noSpace": "L'espace cloud est plein",
        "noSpaceHint": "L'espace cloud de ce groupe est plein et aucun fichier supplémentaire ne peut être ajouté.",
        "confirmDismiss": "Que ce soit pour dissoudre le groupe",
        "dismissHint": "Après la dissolution, les fichiers de groupe ne peuvent pas être récupérés!",
        "confirmLeave": "Que ce soit pour quitter le groupe",
        "okText": "Créer",
        "cancelText": "Annuler",
        "createFail": "La création a échoué, veuillez réessayer",
        "urlCopied": "Le lien d'invitation a été copié dans le presse-papiers",
        "invalidName": "Nom illégal",
        "deleteFile": "supprimer",
        "ok": "D'accord",
        "exit": "Sortie",
        "fileNameLimit": "La longueur maximale du nom du fichier est 100",
        "rename": "Renommer",
        "spaceDeleted": "Cet espace a été dissous ou vous n'avez pas la permission pour cet espace, veuillez contacter l'administrateur de l'espace pour confirmation.",
        "create": "Nouveau",
        "memberManage": "Gestion des membres",
        "setting": "Paramètre",
        "permissionExplanation": "Explication de l'autorisation",
        "explanations": {
            "vip": "Utilisateurs-VIP",
            "noVip": "Utilisateurs non-VIP",
            "noVipTip": "Ne peuvent pas créer d'espaces de stockage, ne peuvent pas ajouter de nouveaux fichiers aux espaces de stockage. Toutes les autres autorisations de rôle correspondent à celles des utilisateurs VIP.",
            "owner": "Propietario: el creador del espacio. Administra los miembros y tiene todos los permisos de los archivos del espacio.",
            "manager": "Gérable : peut gérer les membres, ajouter, modifier et supprimer les fichiers de l'espace de stockage.",
            "editor": "Modifiable : peut ajouter, modifier et supprimer des fichiers de l'espace de stockage.",
            "reader": "Visualisable : peut seulement visualiser les fichiers de l'espace."
        },
        "spaceName": "Nom de l'espace",
        "changeName": "Modifier",
        "deleteSpace": "Supprimer l'espace",
        "deleteSpaceTip": "En cas de suppression, l'espace sera dissous. Tous les fichiers de l'espace seront supprimés et ne pourront pas être récupérés.",
        "delete": "Supprimer",
        "dropTip": {
            "manager": "Gérez l'espace et les membres",
            "editor": "Créez et modifiez des fichiers",
            "reader": "Visualisez uniquement"
        },
        "tip": "Messages",
        "deleteFileTip": "Une fois les fichiers projet supprimés, ils ne peuvent plus être récupérés. Voulez-vous vraiment les supprimer ?",
        "deleteFile": "Supprimer",
        "notTem": "Aucun fichier créé dans cette équipe pour le moment",
        "spaceName": "空间名称",
        "creator": "创建者",
        "name": "Nom de fichier",
        "time": "Heure de création",
        "noFileNameTip": "Veuillez entrer le nom du fichier"
      },
      "de": {
        "notTem": "Noch keine erstellten Dateien in diesem Team",
        "myTeam": "Mannschaften",
        "gridView": "Rasteransicht",
        "listView": "Listenansicht",
        "name": "Dateiname",
        "time": "Erstellungszeitpunkt",
        "creator": "Ersteller",
        "size": "Größe",
        "modDate": "Datum ändern",
        "createFile": "Datei erstellen",
        "importFile": "Datei importieren",
        "editTeamName": "Gruppenname erstellen",
        "dismissTeam": "Gruppe löschen",
        "leaveTeam": "Das Team verlassen",
        "help": "Hilfe",
        "teamMembers": "Gruppenmitglieder",
        "add": "Hinzufügen",
        "more": "Mehr",
        "removeMember": "Berechtigungen entfernen",
        "inviteUrl": "Einladungslink",
        "urlHint": "Teilen Sie den folgenden Link, damit Mitglieder den Bereich beitreten können. Der Link ist 60 Minuten lang gültig.",
        "refresh": "Aktualisieren",
        "copyUrl": "Link kopieren",
        "memberRole": [
            null,
            "Leser",
            "Manager",
            "Editor",
            "Vorbehalter"
        ],
        "readerHint": "Leser: Kann nur Gruppendateien anzeigen",
        "editorHint": "Redakteuer：Kann Gruppendateien anzeigen und bearbeiten",
        "adminHint": "Admin: Kann Gruppendateien anzeigen, bearbeiten und löschen. Kann Gruppenmitglieder hinzufügen, verwalten und entfernen",
        "ownerHint": "Besitzer: Kann Gruppendateien anzeigen, bearbeiten und löschen. Kann alle drei oben genannten Arten von Gruppenmitgliedern hinzufügen, verwalten und entfernen",
        "noSpace": "Speicher voll",
        "noSpaceHint": "Der Cloud-Speicher dieser Gruppe ist voll und es können keine weiteren Dateien hinzugefügt werden.",
        "confirmDismiss": "Möchten Sie diese Gruppe wirklich löschen?",
        "dismissHint": "Sie können nicht mehr auf Gruppendateien zugreifen und diese wiederherstellen, sobald die Gruppe gelöscht wurde.",
        "confirmLeave": "Sie sind sicher, dass Sie die Gruppe verlassen?",
        "okText": "Sichern",
        "ok": "Sichern",
        "cancelText": "Abbrechen",
        "createFail": "Die Erstellung ist fehlgeschlagen. Bitte versuchen Sie es erneut",
        "urlCopied": "Der Einladungslink wurde in die Zwischenablage kopiert.",
        "invalidName": "Ungültiger name",
        "create": "Neu",
        "ok": "In Ordnung",
        "exit": "Ausgang",
        "fileNameLimit": "Die maximale Länge des Dateinamens beträgt 100",
        "rename": "Umbenennen",
        "spaceDeleted": "Dieser Raum wurde aufgelöst oder Sie haben keine Berechtigung für diesen Raum, bitte kontaktieren Sie den Raumadministrator zur Bestätigung.",
        "memberManage": "Mitgliederverwaltung",
        "setting": "Einstellung",
        "permissionExplanation": "Berechtigungserläuterung",
        "explanations": {
            "vip": "VIP-Benutzer",
            "noVip": "Nicht-VIP-Benutzer",
            "noVipTip": "Können keine Räume erstellen und keine neuen Dateien für den Bereich hinzufügen, die restlichen Rollenberechtigungen entsprechen denen von VIP-Benutzern.",
            "owner": "Eigentümer: Der Ersteller des Bereichs. Verwaltet Mitglieder und hat alle Dateiberechtigungen in dem Bereich.",
            "manager": "Verwaltung: Kann Mitglieder ändern, Dateien in Bereichen hinzufügen, bearbeiten und löschen.",
            "editor": "Bearbeitung: Kann Dateien in Bereichen hinzufügen, bearbeiten und löschen.",
            "reader": "Anzeige: Kann nur Bereichsdateien anzeigen."
        },
        "spaceName": "Bereichsname",
        "changeName": "Ändern",
        "deleteSpace": "Bereich löschen",
        "deleteSpaceTip": "Nach dem Löschen ist der Bereich nicht mehr verfügbar. Alle Dateien innerhalb dieses Bereichs werden gelöscht und können nicht",
        "delete": "Löschen",
        "dropTip": {
            "manager": "Verwaltet Bereiche und Mitglieder",
            "editor": "Erstellt und bearbeitet Dateien",
            "reader": "Kann nur anzeigen"
        },
        "tip": "Nachricht",
        "deleteFileTip": "Einmal gelöschte Projektdateien können nicht wiederhergestellt werden. Möchten Sie sie wirklich löschen?",
        "deleteFile": "Löschen",
        "name": "Dateiname",
        "time": "Erstellungszeit",
        "noFileNameTip": "Bitte geben Sie den Dateinamen ein"
      },
      "jp": {
        "myTeam": "チーム",
        "gridView": "グリッドビュー",
        "listView": "リストビュー",
        "fileName": "ファイル名",
        "creator": "作者",
        "size": "サイズ",
        "modDate": "更新日",
        "createFile": "ファイルを作成",
        "importFile": "ファイルをインポート",
        "editTeamName": "グループ名を編集",
        "dismissTeam": "グループを解散",
        "leaveTeam": "チームから抜ける",
        "help": "ヘルプ",
        "teamMembers": "グループメンバー",
        "add": "追加",
        "more": "その他",
        "removeMember": "権限を削除",
        "inviteUrl": "招待リンク",
        "urlHint": "このスペースにメンバーを招待するには、次のリンクを共有します。このリンクは60分間有効です。",
        "refresh": "更新",
        "copyUrl": "リンクをコピー",
        "memberRole": [
            null,
            "閲覧者",
            "編集者",
            "管理者",
            "所有者"
        ],
        "readerHint": "閲覧者：グループファイルを閲覧できます",
        "editorHint": "編集者：グループファイルを編集および閲覧できます",
        "adminHint": "マネージャー：上記のすべての権限とグループファイルの削除、新しいユーザーの招待、および上記の2人のユーザーの削除",
        "ownerHint": "所有者：上記のすべての権限と管理者の削除",
        "noSpace": "クラウドスペースがいっぱいです",
        "noSpaceHint": "このグループのクラウドスペースがいっぱいで、これ以上ファイルを追加できません。",
        "confirmDismiss": "グループを解散しますか",
        "dismissHint": "解散後、グループファイルを取得できなくなります！",
        "confirmLeave": "グループから退出しますか？",
        "okText": "確認",
        "cancelText": "キャンセル",
        "createFail": "作成に失敗しました。もう一度お試しください",
        "urlCopied": "招待リンクがクリップボードにコピーされました",
        "invalidName": "無効な名前",
        "deleteFile": "削除",
        "ok": "了解",
        "exit": "終了",
        "fileNameLimit": "ファイル名の最大長は100です",
        "rename": "名前を変える",
        "spaceDeleted": "このスペースは解散されました、またはあなたはこのスペースの権限を持っていません、スペースの管理者に確認してください。",
        "create": "新着",
        "memberManage": "メンバー管理",
        "setting": "設定",
        "permissionExplanation": "権限の説明",
        "explanations": {
            "vip": "VIPユーザー",
            "noVip": "VIP以外のユーザー",
            "noVipTip": "スペースの作成や、スペースへの新しいファイルの追加はできません。その他のロール権限はすべてVIPユーザーと同じです。",
            "owner": "所有者：スペースの作成者。メンバーを管理し、スペース内のすべてのファイル権限を保有します。",
            "manager": "管理可能：メンバーの変更、スペースでのファイルの追加、編集、削除が可能です。",
            "editor": "編集可能：スペースでのファイルの追加、編集、削除が可能です。",
            "reader": "表示可能：スペース内のファイルの表示のみ可能です。"
        },
        "spaceName": "スペース名",
        "changeName": "変更",
        "deleteSpace": "スペースを削除",
        "deleteSpaceTip": "スペースを削除すると、スペース内のすべてのファイルが削除され、復元できなくなります",
        "delete": "削除",
        "dropTip": {
            "manager": "スペースとメンバーの管理",
            "editor": "ファイルの作成と編集",
            "reader": "表示のみ"
        },
        "tip": "メッセージ",
        "deleteFileTip": "削除したプロジェクトファイルは復元できません。削除しますか？",
        "deleteFile": "削除",
        "notTem": "このチームではまだファイルが作成されていません",
        "name": "ファイル名",
        "time": "作成時間",
        "noFileNameTip": "ファイル名を入力してください"
      },
      "es": {
        "myTeam": "equipos",
        "gridView": "Vista de cuadrícula",
        "listView": "Vista de la lista",
        "fileName": "Nombre del archivo",
        "creator": "Creador",
        "size": "Talla",
        "modDate": "Fecha modificada",
        "createFile": "Crea un archivo",
        "importFile": "Importar archivo",
        "editTeamName": "Editar nombre del grupo",
        "dismissTeam": "Eliminar el grupo",
        "leaveTeam": "Abandonar el equipo",
        "help": "Ayuda",
        "teamMembers": "Miembros del grupo",
        "add": "Añadir",
        "more": "Más",
        "removeMember": "Eliminar permisos",
        "inviteUrl": "Enlace de invitación",
        "urlHint": "Comparte el siguiente enlace para invitar a miembros a unirse al espacio. El enlace es válido durante 60 minutos.",
        "refresh": "Actualizar",
        "copyUrl": "Copiar link",
        "memberRole": [
            null,
            "Lector",
            "Editor",
            "Administrador",
            "Dueño"
        ],
        "readerHint": "Lector: solo puede ver archivos de grupo",
        "editorHint": "Editor: puede ver y editar archivos de grupo",
        "adminHint": "Administrador: puede ver, editar y eliminar archivos de grupo; pueden agregar, administrar y eliminar miembros del grupo",
        "ownerHint": "Propietario: puede ver, editar y eliminar archivos de grupo; pueden agregar, administrar y eliminar los tres tipos de miembros del grupo anteriores",
        "noSpace": "El almacenamiento en la nube está lleno",
        "noSpaceHint": "El almacenamiento en la nube de este grupo está lleno y no se pueden agregar más archivos.",
        "confirmDismiss": "¿Estás seguro de que deseas eliminar este grupo?",
        "dismissHint": "Ya no puede acceder y restaurar archivos de grupo una vez que se elimina el grupo.",
        "confirmLeave": "¿Estás seguro de que quieres salir?",
        "okText": "Confirmar",
        "cancelText": "Cancelar",
        "createFail": "Error de creación, inténtalo de nuevo.",
        "urlCopied": "El enlace de invitación se ha copiado en el portapapeles.",
        "invalidName": "Nombre inválido",
        "create": "Nuevo",
        "memberManage": "Administración de miembros",
        "setting": "Configuración",
        "permissionExplanation": "Explicación del permiso",
        "explanations": {
            "vip": "Usuarios VIP",
            "noVip": "Usuarios no VIP",
            "noVipTip": "No pueden crear espacios ni añadir archivos nuevos en ellos. Todos los otros permisos de este rol son los mismos que los de los usuarios VIP.",
            "owner": "Propietario: el creador del espacio. Administra los miembros y tiene todos los permisos de los archivos del espacio.",
            "manager": "Administrador: puede modificar los miembros y añadir archivos al espacio, así como editarlos y eliminarlos.",
            "editor": "Editor: puede añadir archivos al espacio, así como, editarlos y eliminarlos. ",
            "reader": "Lector: solo puede ver los archivos del espacio."
        },
        "spaceName": "Nombre del espacio",
        "changeName": "Cambiar",
        "deleteSpace": "Eliminar espacio",
        "deleteSpaceTip": "Tras eliminarlo, el espacio se disolverá. Todos los archivos se eliminarán y no se podrán recuperar.",
        "delete": "Eliminar",
        "dropTip": {
            "manager": "Gestiona el espacio y sus miembros",
            "editor": "Crea y edita archivos",
            "reader": "Solo lectura"
        },
        "tip": "Mensaje",
        "deleteFileTip": "Una vez eliminados los archivos del proyecto, no se pueden recuperar. ¿Seguro que deseas eliminarlos?",
        "deleteFile": "Eliminar",
        "notTem": "Noch keine erstellten Dateien in diesem Team",
        "ok": "De acuerdo",
        "exit": "Salir",
        "fileNameLimit": "La longitud máxima del nombre del archivo es 100",
        "rename": "Renombrar",
        "spaceDeleted": "Este espacio ha sido disuelto o no tienes permiso para este espacio, por favor contacta al administrador del espacio para confirmación.",
        "name": "Nombre del archivo",
        "time": "Hora de creación",
        "noFileNameTip": "Por favor ingrese el nombre del archivo"
      },
      "pt": {
        "myTeam": "times",
        "gridView": "Visualização em Grelha",
        "listView": "Visualização em Lista",
        "fileName": "Nome do ficheiro",
        "creator": "Autor",
        "size": "Tamanho",
        "modDate": "Data modificada",
        "createFile": "Criar ficheiro",
        "importFile": "Importar arquivo",
        "editTeamName": "Editar nome do grupo",
        "dismissTeam": "Eliminar o grupo",
        "leaveTeam": "Sair da equipe",
        "help": "Ajuda",
        "teamMembers": "Membros do grupo",
        "add": "Adicionar",
        "more": "Mais",
        "removeMember": "Remover permissões",
        "inviteUrl": "Ligação de convite",
        "urlHint": "Compartilhe o link a seguir para convidar membros a participarem do espaço. O link é válido por 60 minutos.",
        "refresh": "Atualizar",
        "copyUrl": "Copiar ligação",
        "memberRole": [
            null,
            "Leitor",
            "Editor",
            "Gerente",
            "Proprietário"
        ],
        "readerHint": "Leitor: apenas pode ver os ficheiros do grupo",
        "editorHint": "Editor: pode ver e editar os ficheiros do grupo",
        "adminHint": "Administrador: pode ver, editar e eliminar os ficheiros do grupo; pode adicionar, gerir e remover membros do grupo",
        "ownerHint": "Proprietário: pode ver, editar e eliminar os ficheiros do grupo; pode adicionar, gerir e remover todos os três tipos anteriores de membros do grupo",
        "noSpace": "O armazenamento da cloud está cheio.",
        "noSpaceHint": "O armazenamento da cloud deste grupo está cheio e não podem ser adicionados mais ficheiros.",
        "confirmDismiss": "Tem a certeza que deseja eliminar este grupo?",
        "dismissHint": "Já não pode acessar ou restaurar ficheiros do grupo, uma vez que o grupo foi eliminado.",
        "confirmLeave": "Tem a certeza que deseja sair?",
        "okText": "Ok",
        "cancelText": "Cancelar",
        "createFail": "A criação falhou, por favor tente novamente",
        "urlCopied": "A ligação de convite foi copiada para a área de transferência.",
        "invalidName": "Nome Inválido",
        "deleteFile": "excluir",
        "ok": "OK",
        "exit": "Sair",
        "fileNameLimit": "O comprimento máximo do nome do arquivo é 100",
        "rename": "Renomear",
        "spaceDeleted": "Este espaço foi dissolvido ou você não tem permissão para este espaço, por favor entre em contato com o administrador do espaço para confirmação.",
        "create": "Novo",
        "memberManage": "Gerenciamento de membros",
        "setting": "Configuração",
        "permissionExplanation": "Explicação da permissão",
        "explanations": {
            "vip": "Usuários VIP",
            "noVip": "Usuários não VIP",
            "noVipTip": "Não podem criar espaços ou adicionar novos arquivos ao espaço. As demais permissões de função são iguais às dos usuários VIP.",
            "owner": "Proprietário: o criador do espaço. Gerencia membros e tem todas as permissões de arquivo no espaço.",
            "manager": "Gerenciável: é possível modificar membros, bem como adicionar, editar e excluir arquivos no espaço.",
            "editor": "Editável: é possível adicionar, editar e excluir arquivos no espaço.",
            "reader": "Visível: só é possível visualizar arquivos do espaço."
        },
        "spaceName": "Nome do espaço",
        "changeName": "Alterar",
        "deleteSpace": "Excluir espaço",
        "deleteSpaceTip": "Após a exclusão, o espaço será desativado. Todos os arquivos que estiverem dentro do espaço serão excluídos e não poderão ser recuperados",
        "delete": "Excluir",
        "dropTip": {
            "manager": "Gerencia espaços e membros",
            "editor": "Cria e edita arquivos",
            "reader": "Somente visualiza"
        },
        "tip": "Mensagem",
        "deleteFileTip": "Uma vez que os arquivos do projeto forem excluídos, eles não poderão ser recuperados. Tem certeza de que deseja excluí-los?",
        "deleteFile": "Excluir",
        "notTem": "Ainda não há arquivos criados nesta equipe",
        "name": "Nome do arquivo",
        "time": "Hora da criação",
        "noFileNameTip": "Por favor, digite o nome do arquivo"
      },
      "it": {
        "myTeam": "squadre",
        "gridView": "Vista a Griglia",
        "listView": "Vista a Elenco",
        "fileName": "Nome File",
        "creator": "Creatore",
        "size": "Taglia",
        "modDate": "Data modificata",
        "createFile": "Crea File",
        "importFile": "Importa file",
        "editTeamName": "Modifica Nome Team",
        "dismissTeam": "Elimina il Team",
        "leaveTeam": "Abbandona il team",
        "help": "Aiuto",
        "teamMembers": "Membri del Team",
        "add": "Aggiungi",
        "more": "Altro",
        "removeMember": "Rimuovi autorizzazioni",
        "inviteUrl": "Link di Invito",
        "urlHint": "Condividi il collegamento seguente per invitare i membri a partecipare. Il collegamento è valido per 60 minuti.",
        "refresh": "Aggiorna",
        "copyUrl": "Copia Link",
        "memberRole": [
            null,
            "Lettore",
            "Editor",
            "Responsabile",
            "Proprietario"
        ],
        "readerHint": "Lettore: può solamente visualizzare i file del team.",
        "editorHint": "Editor: può visualizzare e modificare i file del team.",
        "adminHint": "Amministratore: può visualizzare, modificare ed eliminare i file del team; può aggiungere, gestire e rimuovere membri.",
        "ownerHint": "Proprietario: può visualizzare, modificare ed eliminare i file del team; può aggiungere, gestire e rimuovere membri appartenenti a tutte e tre le categorie sopracitate.",
        "noSpace": "L'archivio cloud è pieno.",
        "noSpaceHint": "L'archivio cloud del team è pieno e, pertanto, non è possibile aggiungervi altri file.",
        "confirmDismiss": "Confermi di voler eliminare il team?",
        "dismissHint": "In seguito all'eliminazione, non sarà più possibile accedere ai file del team o ripristinarli.",
        "confirmLeave": "Confermi di voler uscire?",
        "okText": "OK",
        "cancelText": "Annulla",
        "createFail": "Creazione non riuscita, riprova",
        "urlCopied": "Il link di invito è stato copiato negli appunti.",
        "invalidName": "Nome non Valido",
        "deleteFile": "elimina",
        "ok": "Va bene",
        "exit": "Uscita",
        "fileNameLimit": "La lunghezza massima del nome del file è 100",
        "rename": "Rinominare",
        "spaceDeleted": "Questo spazio è stato sciolto o non hai il permesso per questo spazio, si prega di contattare l'amministratore dello spazio per la conferma.",
        "create": "Nuovo",
        "memberManage": "Gestione dei membri",
        "setting": "Impostazioni",
        "permissionExplanation": "Chiarimenti sulle autorizzazioni",
        "explanations": {
            "vip": "Utenti VIP",
            "noVip": "Utenti che non dispongono dello stato di VIP",
            "noVipTip": "Non possono creare spazi, non possono aggiungere nuovi file nello spazio o altre autorizzazioni pertinenti al ruolo di utente VIP.",
            "owner": "Proprietario: l'utente che ha creato lo spazio. Gestisce i membri, dispone di tutte le autorizzazioni ai file contenuti nello spazio.",
            "manager": "Gestione: può modificare i membri, nonché aggiungere, modificare ed eliminare i file nello spazio.",
            "editor": "Modifica: può aggiungere, modificare ed eliminare i file nello spazio.",
            "reader": "Visualizzazione: può visualizzare solo i file nello spazio."
        },
        "spaceName": "Nome spazio",
        "changeName": "Modifica",
        "deleteSpace": "Elimina spazio",
        "deleteSpaceTip": "Dopo l'eliminazione, lo spazio verrà disattivato. Tutti i file contenuti verranno eliminati e non potranno essere recuperati",
        "delete": "Elimina",
        "dropTip": {
            "manager": "Gestisce spazio e membri",
            "editor": "Crea e modifica file",
            "reader": "Può solo visualizzare"
        },
        "tip": "Messaggi",
        "deleteFileTip": "Una volta eliminati, i file di progetto non possono essere recuperati. Eliminare?",
        "deleteFile": "Elimina",
        "notTem": "Nessun file creato in questo team",
        "name": "Nome del file",
        "time": "Ora della creazione",
        "noFileNameTip": "Inserisci il nome del file"
      },
      "tw": {
        "myTeam": "團隊",
        "gridView": "網格視圖",
        "listView": "列表視圖",
        "fileName": "檔案名",
        "creator": "建立者",
        "size": "大小",
        "modDate": "修改日期",
        "createFile": "建立檔案",
        "importFile": "匯入檔案",
        "editTeamName": "編輯群名稱",
        "dismissTeam": "解散群",
        "leaveTeam": "離開團隊",
        "help": "幫助",
        "teamMembers": "群成員",
        "add": "添加",
        "more": "更多",
        "removeMember": "移除權限",
        "inviteUrl": "邀請連結",
        "urlHint": "分享下列連結以邀請成員加入空間。連結的有效時間為 60 分鐘。",
        "refresh": "重新整理",
        "copyUrl": "複製連結",
        "memberRole": [
            "無",
            "閱讀者",
            "編輯者",
            "管理者",
            "所有者"
        ],
        "readerHint": "閱讀者：只能查看群檔案",
        "editorHint": "編輯者：能夠編輯查看群檔案",
        "adminHint": "管理者：以上所有權限及刪除群檔案、邀請新用戶和刪除以上兩種用戶",
        "ownerHint": "所有者：以上所有權限及刪除管理員",
        "noSpace": "雲端硬碟已滿",
        "noSpaceHint": "此群的雲端硬碟已滿，無法增加更多檔案。",
        "confirmDismiss": "是否解散群",
        "dismissHint": "解散后將無法找回群檔案！",
        "confirmLeave": "是否退出群",
        "okText": "確定",
        "cancelText": "取消",
        "createFail": "建立失敗，請重試",
        "urlCopied": "邀請連結已複製到剪下板",
        "invalidName": "名字不能包特殊字符(& % $ \\ \/ \" : * ? < > | . 😊等)",
        "deleteFile": "刪除",
        "ok": "好的",
        "exit": "退出",
        "fileNameLimit": "文件名称最长为100",
        "rename": "重命名",
        "spaceDeleted": "該空間已解散 或 您尚未有該空間的權限，請聯絡空間管理員確認。",
        "create": "新增",
        "memberManage": "成員管理",
        "setting": "設定",
        "permissionExplanation": "權限說明",
        "explanations": {
            "vip": "VIP 使用者",
            "noVip": "非 VIP 使用者",
            "noVipTip": "無法建立空間、無法在空間新增檔案，其他角色權限則與 VIP 使用者相同。",
            "owner": "擁有者：空間的建立者。管理成員，擁有空間內的所有檔案權限。",
            "manager": "可管理：可修改成員；新增、編輯和刪除空間檔案。",
            "editor": "可編輯：可新增、編輯和刪除空間檔案。",
            "reader": "可檢視：只能檢視空間檔案。"
        },
        "spaceName": "空間名稱",
        "changeName": "變更",
        "deleteSpace": "刪除空間",
        "deleteSpaceTip": "刪除後，空間將會解散。空間內的所有檔案將會刪除，且無法復原",
        "delete": "刪除",
        "dropTip": {
            "manager": "管理空間和成員",
            "editor": "建立、編輯檔案",
            "reader": "僅可檢視"
        },
        "tip": "訊息",
        "deleteFileTip": "專案檔案一旦刪除，便無法復原。確定要刪除？",
        "deleteFile": "刪除",
        "notTem": "尚未在此團隊中建立任何檔案",
        "name": "文件名",
        "time": "创建时间",
        "noFileNameTip": "请输入文件名"
      },
      "kr": {
        "myTeam": "팀",
        "gridView": "그리드 보기",
        "listView": "목록 보기",
        "fileName": "파일 이름",
        "creator": "생성자",
        "size": "크기",
        "modDate": "수정 날짜",
        "createFile": "파일 만들기",
        "importFile": "파일 가져오기",
        "editTeamName": "그룹 이름 편집",
        "dismissTeam": "그룹 해산",
        "leaveTeam": "팀 탈퇴",
        "help": "도움말",
        "teamMembers": "그룹 멤버",
        "add": "추가",
        "more": "더 알아보기",
        "removeMember": "권한 삭제",
        "inviteUrl": "초청 링크",
        "urlHint": "다음 링크를 공유하여 회원들이 공간에 참여하도록 초대합니다. 링크는 60분 동안 유효합니다.",
        "refresh": "새로 고침",
        "copyUrl": "링크 복사",
        "memberRole": [
            null,
            "읽는 사람",
            "편집자",
            "관리자",
            "소유자"
        ],
        "readerHint": "읽기만 가능한 사람：그룹 파일을 보는 권한만 있음",
        "editorHint": "편집이 가능한 사람:그룹 파일을 편집할 수 있음",
        "adminHint": "관리자：모든 권한 소유",
        "ownerHint": "소유자：모든 권한+관리자 삭제 권한",
        "noSpace": "클라우드 공간이 가득 찼습니다",
        "noSpaceHint": "이 그룹의 클라우드 공간이 가득 차서 더 이상 파일을 추가 할 수 없습니다.",
        "confirmDismiss": "그룹 해체 여부",
        "dismissHint": "해체 후에는 그룹 파일을 검색 할 수 없습니다!",
        "confirmLeave": "그룹 탈퇴 여부",
        "okText": "확인",
        "cancelText": "취소",
        "createFail": "만들기 실패했습니다.다시 시도하세요~",
        "urlCopied": "초대 링크가 클립 보드에 복사되었습니다.",
        "invalidName": "이름은 특수 문자를 포함 할 수 없습니다.",
        "deleteFile": "삭제",
        "ok": "알겠습니다",
        "exit": "나가기",
        "fileNameLimit": "파일 이름의 최대 길이는 100입니다",
        "rename": "이름 변경",
        "spaceDeleted": "이 공간은 해산되었거나 당신은 이 공간에 대한 권한이 없습니다, 공간 관리자에게 확인해주세요.",
        "create": "신규",
        "memberManage": "구성원 관리",
        "setting": "설정",
        "permissionExplanation": "권한 설명",
        "explanations": {
            "vip": "VIP 사용자",
            "noVip": "VIP가 아닌 사용자",
            "noVipTip": "공간을 만들 수 없고, 새 파일을 공간에 추가할 수 없으며, 다른 모든 역할 권한이 VIP 사용자와 동일합니다.",
            "owner": "소유자: 공간을 만든 사람. 구성원을 관리하고 공간의 파일에 대한 모든 권한을 가집니다.",
            "manager": "관리 가능: 구성원을 수정하고 공간에 파일을 추가, 편집 및 삭제할 수 있습니다.",
            "editor": "편집 가능: 공간에 파일을 추가, 편집 및 삭제할 수 있습니다.",
            "reader": "확인 가능: 공간 파일을 보는 것만 할 수 있습니다."
        },
        "spaceName": "공간 이름",
        "changeName": "변경",
        "deleteSpace": "공간 삭제",
        "deleteSpaceTip": "삭제되면 공간이 해체됩니다. 공간 내의 모든 파일이 삭제되며 복구할 수 없습니다.",
        "delete": "삭제",
        "dropTip": {
            "manager": "공간 및 구성원 관리",
            "editor": "파일 생성, 편집",
            "reader": "보기만 가능"
        },
        "tip": "메시지",
        "deleteFileTip": "프로젝트 파일이 삭제되면 복구할 수 없습니다. 삭제하시겠습니까?",
        "deleteFile": "삭제",
        "notTem": "아직 이 팀에서 생성된 파일이 없습니다.",
        "name": "파일 이름",
        "time": "생성 시간",
        "noFileNameTip": "파일 이름을 입력하세요"
      }
    }
</i18n>
